export enum SponsorType {
  Ice = 0,
  CustomerService = 1,
  Dealer = 2,
}

export class Sponsor {
  sponsorId: string;
  fullName: string;
  email: string;
  team: string;
  sponsorType: SponsorType;
}
